<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
  <div class="flex flex-col items-center gap-6">
    <!-- Logo/Brand Area -->
    <div class="flex flex-col items-center gap-4">
      <div
        class="flex h-20 w-20 items-center justify-center rounded-2xl bg-white shadow-lg ring-1 ring-slate-200">
        <lucide-icon name="shield-check" class="h-10 w-10 text-[#177991]" />
      </div>
      <div class="text-center">
        <h1 class="text-2xl font-semibold text-slate-800">{{ title }}</h1>
        <p class="mt-1 text-sm text-slate-500">
          @if (entraAuthService.requiresIframeLogin()) {
            {{ t().iframeSubtitle }}
          } @else {
            {{ t().subtitle }}
          }
        </p>
      </div>
    </div>

    @if (entraAuthService.requiresIframeLogin()) {
      <!-- Iframe popup login area -->
      <div class="flex w-80 flex-col items-center gap-4 text-center">
        <lucide-icon name="monitor" class="h-8 w-8 text-slate-400" />
        <p class="text-sm leading-relaxed text-slate-600">
          {{ t().iframeMessage }}
        </p>

        @if (entraAuthService.popupBlocked()) {
          <div
            class="flex w-full items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 p-3 text-left"
            role="alert">
            <lucide-icon
              name="triangle-alert"
              class="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
            <p class="text-sm text-amber-800">
              {{ t().iframePopupBlockedMessage }}
            </p>
          </div>
        }

        <button
          type="button"
          class="flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg bg-[#177991] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#146680] disabled:cursor-not-allowed disabled:opacity-60"
          (click)="triggerPopupLogin()">
          <lucide-icon name="log-in" class="h-4 w-4" />
          @if (entraAuthService.popupBlocked()) {
            {{ t().iframeRetryButton }}
          } @else {
            {{ t().iframeLoginButton }}
          }
        </button>
      </div>
    } @else {
      <!-- Normal redirect flow loading area -->
      <div class="flex flex-col items-center gap-3">
        <lucide-icon
          name="loader-circle"
          class="h-8 w-8 animate-spin text-[#177991]" />
        <p class="text-sm font-medium text-slate-600">
          {{ t().message }}
        </p>
      </div>

      <!-- Progress Indicator -->
      <div class="w-64">
        <div class="h-1 overflow-hidden rounded-full bg-slate-200">
          <div
            class="h-full w-2/3 animate-pulse rounded-full bg-[#177991]"></div>
        </div>
      </div>
    }
  </div>
</div>
